import { createSelector } from 'reselect';

const selectSettlementRequestItems = (state: any) => state.settlementRequestItems;


export const selectSettlementRequestItemCurrentItem = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.current);

export const selectSettlementRequestItemsListItems = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.list);

export const selectSettlementRequestItemItemById = (itemId: any) =>
    createSelector(selectSettlementRequestItemsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSettlementRequestItemQueryItems = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.query);

export const selectSettlementRequestItemCreatedItem = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.create);

export const selectSettlementRequestItemUpdatedItem = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.update);

export const selectSettlementRequestItemReadItem = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.read);

export const selectSettlementRequestItemDeletedItem = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.delete);

export const selectSettlementRequestItemSearchedItems = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.search);

export const selectSettlementRequestItemItemsCount = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.count);

export const selectSettlementRequestItemItemsFilter = createSelector([selectSettlementRequestItems], (settlementRequestItems) => settlementRequestItems.filter);